import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Popular tag - Get All (Read)
export const GetAll = createAsyncThunk(
  "food-services/food-label/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.FoodServices.FoodLabel}?name=${filter?.name || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Get (Read)
export const GetSingle = createAsyncThunk(
  "food-services/food-label/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.FoodServices.FoodLabel}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Popular tag - Create (Add)
export const Create = createAsyncThunk(
  "food-services/food-label/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.FoodServices.FoodLabel, data);
      return res; // The new tag object
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Update
export const Update = createAsyncThunk(
  "food-services/food-label/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.FoodServices.FoodLabel}/${id}`, data);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Popular tag - Delete
export const Delete = createAsyncThunk(
  "food-services/food-label/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.FoodServices.FoodLabel}/${id}`);
      return id; // Return the id of the deleted tag
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Status
export const StatusFoodLabel = createAsyncThunk(
  "food-services/food-label/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.FoodServices.FoodLabel}/${id}`);
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "foodlabel",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (populartag) => populartag.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (populartag) => populartag.id !== action.payload.id); // Remove the tag with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusFoodLabel.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusFoodLabel.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (populartag) => populartag.id !== action.payload.id); // Remove the tag with the deleted id
      })
      .addCase(StatusFoodLabel.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
